import React from 'react'
import ParcelSearch from '../search/components/ParcelSearch'


const SearchPanel: React.FC = () => {
  return (
    <aside id="sidebar">
      <section>
        <h3>Search</h3>
        <ParcelSearch />
      </section>
    </aside>
  )
}

export default SearchPanel